<template>
  <div class="field-wrapper">
    <div class="campaign-card-header">
      <i class="yuzu-icon yuzu-ai"></i>
      <p class="title">{{ $t('app.campaign.newPage.confirmJob.title') }}</p>
    </div>
    <p class="subtitle jobchoice" v-if="foundJobs">
      <span class="text">{{ $t("app.campaign.newPage.closestJobs") }}</span>
      <span class="text yuzuai">&nbsp;{{ $t('app.campaign.newPage.yuzuAI') }}</span>&nbsp;:&nbsp;
      <v-select class="selector" :placeholder="$t('app.campaign.newPage.selectSimilarJob')" :options="jobChoices" label="job_title" item-title="job_title" item-value="job_title" v-model="model" />
    </p>
    <p class="subtitle jobchoice" v-else>
      {{ $t("app.campaign.newPage.jobNotIdentified") }}
      <span class="yuzuai">&nbsp;{{ $t('app.campaign.newPage.yuzuAI') }}</span>.
    </p>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/style/variables.scss";

.field-wrapper {
  width: 100%;

  .campaign-card-header {
    display: flex;
    gap: 8px;
    align-items: center;

    .title {
      color: var(--secondary-color);
      font-family: $bioSans;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 24px; /* 150% */
    }
  }

  .jobchoice {
    display: flex;
    align-items: center;
  }

  .text {
    flex-grow: 0;
    flex-shrink: 0;
  }

  .selector {
    //margin-left: 8px;
    flex-shrink: 1;
  }

  ::v-deep(.v-select .vs__dropdown-toggle .vs__selected) {
    margin: 4px 0 !important;
  }

  ::v-deep(.v-select .vs__dropdown-toggle .vs__actions) {
    padding: 0 6px;
  }

  ::v-deep(.v-select .vs__dropdown-toggle .vs__selected-options ) {
    padding: 0 0 0 6px;
  }

  ::v-deep(.v-select .vs__dropdown-toggle .vs__selected-options > .vs__search) {
    margin: 0;
  }
}
</style>

<script setup lang="ts">
import { CampaignCreation } from '@/stores/campaign';
import { AISkillsResult } from '../../NewCampaignView.vue';

const { t } = useI18n();

const props = defineProps<{
  yuzuAiResult: AISkillsResult,
  modelValue: CampaignCreation,
}>();

const state = reactive<{
  selectedJob: string,
}>({
  selectedJob: props?.modelValue?.campaign?.job_title || "",
});

const emit = defineEmits<{
  (e: 'update:modelValue', value: CampaignCreation): void
  (e: 'valid', value: boolean): void
}>();

const foundJobs = computed(() => {
  return props?.yuzuAiResult?.results.length;
});

const jobChoices = computed(() => {
  let jobs: any[] = [];
  jobs = jobs.concat(props.yuzuAiResult.results);
  jobs.push({
    id: "nojob",
    job_title: t("app.campaign.newPage.noSimilarJob"),
  });
  return jobs;
});

const model = computed({
  get: () => state.selectedJob,
  set: (value: any) => {
    state.selectedJob = value;
    props.modelValue.campaign.job_title = value.job_title || value;
    if (value?.job_title?.length || value?.length) emit('valid', true);
    emit('update:modelValue', props.modelValue);
  }
});

onMounted(() => {
  state.selectedJob = props.modelValue.campaign.job_title || props.yuzuAiResult.results[0].job_title || "";
  props.modelValue.campaign.job_title = state?.selectedJob?.job_title || state.selectedJob;
  emit('valid', true);
  emit('update:modelValue', props.modelValue);
});

</script>